import { useEffect, useState } from 'react';
import api from '../lib/api';

const readable = value => String(value || 'unmeasured').replaceAll('_', ' ');

export default function GuardianAvailabilityStatus() {
  const [guardian, setGuardian] = useState(null);
  const [availability, setAvailability] = useState(null);
  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    const deadline = setTimeout(() => controller.abort(), 10000);
    async function load() {
      await Promise.all([
        (async () => {
          try {
            const { data } = await api.get('/admin/estate-guardian', { signal: controller.signal });
            if (active) setGuardian(data.monitoring);
          } catch { if (active) setGuardian({ status: 'unmeasured', reasons: ['guardian_reporting_unavailable'] }); }
        })(),
        (async () => {
          try {
            const response = await fetch('/health/public-availability', { signal: controller.signal, credentials: 'omit', cache: 'no-store' });
            if (!response.ok) throw new Error('watch_unavailable');
            const value = await response.json();
            if (!['healthy', 'degraded', 'unmeasured'].includes(value.status)) throw new Error('watch_invalid');
            const observed = Date.parse(value.observed_at || '');
            if (!Number.isFinite(observed) || observed > Date.now() + 60000 || Date.now() - observed > 600000) {
              value.status = 'unmeasured'; value.reasons = ['watch_heartbeat_stale'];
            }
            if (active) setAvailability(value);
          } catch { if (active) setAvailability({ status: 'unmeasured', reasons: ['availability_watch_unavailable'] }); }
        })(),
      ]);
      clearTimeout(deadline);
    }
    load();
    return () => { active = false; clearTimeout(deadline); controller.abort(); };
  }, []);
  return (
    <section aria-label='Guardian evidence status' className='mb-6 border-y border-white/15 py-4 text-sm'>
      <h3 className='font-semibold text-white'>Guardian evidence</h3>
      <dl className='mt-2 grid gap-2 sm:grid-cols-2'>
        <div><dt className='text-white/60'>Audit evidence</dt><dd className='capitalize'>{readable(guardian?.status)}</dd></div>
        <div><dt className='text-white/60'>Public availability</dt><dd className='capitalize'>{readable(availability?.status)}</dd></div>
        <div><dt className='text-white/60'>Healthy baseline</dt><dd>{guardian?.baseline_available ? 'Available' : 'Baseline unavailable'}</dd></div>
        <div><dt className='text-white/60'>Last availability observation</dt><dd>{availability?.observed_at || 'Unmeasured'}</dd></div>
      </dl>
      {[...(guardian?.reasons || []), ...(availability?.reasons || [])].length > 0 && (
        <ul className='mt-2 text-white/70'>{[...new Set([...(guardian?.reasons || []), ...(availability?.reasons || [])])].map(reason => <li key={reason}>{readable(reason)}</li>)}</ul>
      )}
    </section>
  );
}
